import { UpsellAnalyticsTotalsSnapshotSchema } from "@redotech/redo-model/analytics/analytics";
import z from "zod/v4";

export const getUpsellAnalytics = {
  name: "getUpsellAnalytics",
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    page: z.number().positive().optional(),
    pageSize: z.number().positive().optional(),
  }),
  output: z.object({
    current: z.array(UpsellAnalyticsTotalsSnapshotSchema),
    previous: z.array(UpsellAnalyticsTotalsSnapshotSchema),
    totalCount: z.number().optional(),
  }),
};
